/**
 * The ONLY module that imports driver.js (MIT, 1.8.0) and its stylesheet.
 * Loaded by dynamic import from the provider, so the library is a separate
 * chunk that returning teachers (tour already seen, hints already shown)
 * never download.
 */
let enginePromise = null;

export function loadTourEngine() {
  if (!enginePromise) {
    enginePromise = Promise.all([
      import(/* webpackChunkName: "onboarding-driver" */ 'driver.js'),
      import(/* webpackChunkName: "onboarding-driver" */ 'driver.js/dist/driver.css'),
    ]).then(([mod]) => ({ driver: mod.driver }));
    enginePromise.catch(() => { enginePromise = null; });
  }
  return enginePromise;
}

export function prefersReducedMotion() {
  try {
    return typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;
  } catch (e) {
    return false;
  }
}

/** Shared driver config: no overlay-click or Esc handling inside driver — the provider owns Skip. */
export function baseDriverConfig() {
  const reduced = prefersReducedMotion();
  return {
    animate: !reduced,
    smoothScroll: false,
    allowClose: false,
    allowKeyboardControl: false,
    overlayClickBehavior: () => {}, // overlay click is a no-op (never a skip)
    overlayOpacity: 0.6,
    stagePadding: 8,
    stageRadius: 8,
    popoverClass: 'onboarding-popover',
    disableActiveInteraction: true,
  };
}
